import axios from "axios";

const ORIGIN = process.env.REACT_APP_BACKEND_URL || window.location.origin;
export const API = `${ORIGIN}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });
http.interceptors.response.use((r) => r, (e) => {
  if (e?.response?.status === 401 && !e.config?.url?.startsWith("/auth/")) window.dispatchEvent(new Event("dainuok:unauthorized"));
  return Promise.reject(e);
});

export const bridgeScriptUrl = (clientKey) =>
  `${API}/bridge/script?client_id=${clientKey}&api_url=${encodeURIComponent(ORIGIN)}`;

export const mediaUrl = (path) => (path ? `${API}/media/${path}` : "");
export const downloadUrl = (song) =>
  `${API}/media/${song.audio_path}?download=${encodeURIComponent((song.title || "daina") + ".mp3")}`;

export const getPref = (k, items) => {
  const v = localStorage.getItem(`dainuok_${k}`);
  return items.some((x) => x.id === v) ? v : items[0].id;
};
export const setPref = (k, v) => localStorage.setItem(`dainuok_${k}`, v);

export const getAuthorName = () => localStorage.getItem("dainuok_author") || "";
export const setAuthorName = (n) => localStorage.setItem("dainuok_author", n);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ") || "Neteisingi duomenys";
  return (typeof d === "string" && d) || "Įvyko klaida";
};

export async function streamLyrics(body, onChunk) {
  const { data } = await http.post("/lyrics", body);
  for (;;) {
    await new Promise((r) => setTimeout(r, 1500));
    const { data: job } = await http.get(`/lyrics/${data.id}`);
    if (job.text.trim()) onChunk(job.text);
    if (job.status === "error") throw new Error(job.error);
    if (job.status === "done") return job.text;
  }
}
